<template>
  <div class="comments-card__wrapper" :style="customStyle">
    <div class="comments-card">
      <div class="comments-card__title" v-if="showTitle">
        <span>{{ $l('form_label_comments') || 'Comments' }}</span>
        <!-- <span class="refresh__btn">
          <el-button icon="el-icon-refresh" circle @click="getData" />
        </span> -->
      </div>
      <div class="comments-card__content" v-if="!isEmpty">
        <div class="comments-card__content-items__wrapper">
          <div
            class="comments-card__content-items"
            v-for="item in data"
            :key="item.time"
          >
            <div class="comments-card__content-items__time">
              {{ item.time }}
            </div>
            <div
              class="comments-card__content-items__comments-items"
              v-for="comments in item.data"
              :key="comments.commentsCode"
              :class="{ owner: comments.isOwner }"
            >
              <div class="comments_person__mem">
                <b-avatar
                  :src="comments.commentsPersonMemImgUrl"
                  size="medium"
                />
              </div>
              <div
                class="comments_message__context"
                :class="{
                  'image-message': comments.commentsType == 'I',
                  'sample-messsage': comments.commentsType == 'P',
                  'voice-messsage': comments.commentsType == 'V',
                }"
              >
                <span v-if="comments.commentsType == 'T'">
                  {{ comments.commentsMessage }}
                </span>
                <el-image
                  v-if="comments.commentsType == 'I'"
                  :src="comments.thumbImageUrl"
                  fit="contain"
                  @click="previewImage(comments)"
                >
                  <div slot="error">
                    <el-image
                      :src="comments.displayImageUrl"
                      fit="contain"
                      @click="previewImage(comments)"
                    />
                  </div>
                </el-image>
                <div v-if="comments.commentsType == 'P'">
                  <div>{{ comments.sampleStyleNo }}</div>
                  <el-image
                    class="sample-image"
                    fit="contain"
                    :src="
                      !!comments.sampleDefaultImageUrl
                        ? $osscdn(comments.sampleDefaultImageUrl)
                        : '/image/static/img/nopic.jpg'
                    "
                  >
                    <template #error>
                      <img
                        src="/image/static/img/nopic.jpg"
                        style="width: 60px; height: 60px"
                      />
                    </template>
                  </el-image>
                </div>
                <div v-if="comments.commentsType == 'V'">
                  <CommentsAudio
                    :ref="`audio-${comments.commentsCode}`"
                    @play="audioPlay(`audio-${comments.commentsCode}`)"
                    :src="comments.fileUrl"
                    :duration="comments.voiceDurations"
                    :symbolPosition="comments.isOwner ? 'right' : 'left'"
                  />
                </div>
                <i class="el-icon-caret-right" v-if="comments.isOwner" />
                <i class="el-icon-caret-left" v-if="!comments.isOwner" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEmpty" class="comments-card__content empty-data">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>

    <div v-show="false" class="image-viewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listMessageDisplayImage"
        :src="item.url"
        :key="item.code"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import CommentsAudio from '../comments-audio'
export default {
  components: { CommentsAudio },
  props: {
    selectionCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    recordType: { type: String, default: '' },
    showTitle: { type: Boolean, default: true },
    customStyle: { type: String, default: '' },
  },
  data() {
    return {
      localTimeZone: '',
      loading: false,
      data: [],
    }
  },
  computed: {
    listMessageDisplayImage() {
      return (
        this.data
          ?.map((item) => {
            const { data } = item
            if (!data?.length) return []
            return data
              .filter((item) => item.commentsType === 'I')
              .map((comments) => {
                const { commentsCode: code, displayImageUrl: url } = comments
                return { code, url }
              })
          })
          ?.reduce((r, n) => {
            r.push(...n)
            return r
          }, []) || []
      )
    },
    listMessageDisplayImageCode() {
      return this.listMessageDisplayImage.map((item) => item.code)
    },
    isEmpty() {
      return !this.data?.length
    },
  },
  watch: {
    data: {
      handler() {
        setTimeout(() => {
          if (!this.isEmpty) this.scrollToBottom()
        }, 500)
      },
      deep: true,
    },
  },
  // async created() {
  //   await this.getData()
  //   setTimeout(() => {
  //     if (!this.isEmpty) this.scrollToBottom()
  //   }, 100)
  // },
  methods: {
    async fetchData() {
      await this.getData()
      setTimeout(() => {
        if (!this.isEmpty) this.scrollToBottom()
      }, 100)
    },
    async getData() {
      const localTimeZone = await this.loadLocalTimeZone()
      const params = {
        expoMeetingCode: this.expoMeetingCode,
        selectionCode: this.selectionCode,
        recordType: this.recordType,
        localTimeZone,
      }

      this.loading = true
      const res = await this.$api
        .expoMeetingCommentsListApi(params)
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.data = this._dataTransform(res.body.data)
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    _dataTransform(data) {
      if (!data?.length) return []

      const _data = data.reduce((groups, item) => {
        const { commentsLocalTime } = item
        const time = dayjs(commentsLocalTime).format('YYYY/MM/DD HH:mm')
        groups[time] = groups[time] || []
        groups[time].push(item)
        return groups
      }, {})

      let times = Object.keys(_data)
      times = times
        .map((time) => dayjs(time))
        .sort((a, b) => (a.isAfter(b) ? 1 : -1))
        .map((time) => time.format('YYYY/MM/DD HH:mm'))
      return times.map((time) => {
        const data = _data[time]
        const _times = dayjs(time)
        const today = dayjs()
        const isToday = _times.isSame(today, 'day')
        return {
          time: isToday ? _times.format('HH:mm') : time,
          data: data.sort((a, b) => {
            const a_commentsLocalTime = dayjs(a.commentsLocalTime)
            const b_commentsLocalTime = dayjs(b.commentsLocalTime)
            return a_commentsLocalTime.isAfter(b_commentsLocalTime) ? 1 : -1
          }),
        }
      })
    },
    previewImage({ commentsCode }) {
      const index = this.listMessageDisplayImageCode.findIndex(
        (code) => code === commentsCode
      )
      if (index < 0) return

      console.log('index >>', index)
      const viewer = this.$el.querySelector('.image-viewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    scrollToBottom() {
      const container = document.querySelector('.comments-card__content')
      const content = document.querySelector(
        '.comments-card__content-items__wrapper'
      )

      const scrollTop =
        content?.clientHeight || 0 - container?.clientHeight || 0

      container.scrollTop = scrollTop
    },
    audioPlay(audioKey) {
      const { $refs } = this
      const refKeys = Object.keys($refs)
      const keys = refKeys.filter((key) => audioKey !== key)
      if (!keys?.length) return
      keys.forEach((key) => {
        $refs[key][0]?.pause()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.comments-card__wrapper {
  --height: 600px;
}
.comments-card__wrapper .comments-card__title {
  font-size: 14px;
  font-weight: 600;
  color: rgba(16, 16, 16, 1);
  line-height: 20px;
  margin-bottom: 6px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .refresh__btn {
    padding-right: 10px;
    .el-button.is-circle {
      border-radius: 50% !important;
      padding: 6px;
    }
  }
}
.comments-card__wrapper .comments-card__content {
  line-height: 20px;
  border-radius: 10px;
  font-size: 14px;
  color: rgba(16, 16, 16, 1);
  background-color: rgba(247, 247, 247, 1);
  padding: 10px;
  height: var(--height);
  overflow: auto;
  &.empty-data {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
  &::-webkit-scrollbar-corner {
    background: #179a16;
  }

  .comments-card__content-items {
    scroll-snap-align: end;
    .comments-card__content-items__time {
      text-align: center;
      font-size: 12px;
      line-height: 17px;
      color: rgba(165, 166, 165, 1);
      margin: 12px 0;
    }
    .comments-card__content-items__time:first-child {
      margin-top: 0;
    }
    .comments-card__content-items__comments-items {
      position: relative;
      padding-left: 50px;
      margin-bottom: 26px;
      display: flex;
      justify-content: flex-start;
      .comments_person__mem {
        position: absolute;
        left: 0;
        display: flex;
        justify-content: center;
      }
      .comments_message__context {
        background-color: #ffffff;
        padding: 6px;
        border-radius: 5px;
        width: max-content;
        max-width: calc(100% - 40px - 20px);
        font-size: 12px;
        line-height: 1.6;
        position: relative;
        white-space: pre-line;
        word-wrap: break-word;
        word-break: break-all;
        i[class^='el-icon'] {
          color: #ffffff;
          position: absolute;
          font-size: 18px;
          left: -11px;
          top: 4px;
        }
      }

      .comments_message__context.image-message {
        background-color: transparent !important;
        i[class^='el-icon'] {
          display: none;
        }
      }
      .comments_message__context.sample-messsage {
        background-color: #ffffff !important;
        > div {
          div:first-child {
            font-size: 16px;
            font-weight: 600;
            color: #4f4f4f;
          }
        }
        .sample-image {
          margin-top: 4px;
        }
        i[class^='el-icon'] {
          color: #ffffff !important;
        }
      }
      // .comments_message__context.voice-messsage {
      // }
    }
    .comments-card__content-items__comments-items.owner {
      padding-left: 0;
      padding-right: 50px;
      justify-content: flex-end;
      .comments_person__mem {
        left: initial;
        right: 0;
      }
      .comments_message__context {
        background-color: #95ec69;
        i[class^='el-icon'] {
          color: #95ec69;
          position: absolute;
          right: -11px;
          left: initial;
        }
      }
    }
  }
  .comments-card__content-items:last-child {
    .comments-card__content-items__comments-items:last-child {
      margin-bottom: 16px;
    }
  }
}
</style>
